export default "__VITE_ASSET__ab9091d9__"